import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import "./Style.css";

export default function ViewCompany({ showView, closeModal, refreshPage, companyDetails }) {
    const handleClose = () => {
        closeModal();
    };

    const [company, setCompany] = useState(null);

    useEffect(() => {
        if (companyDetails) {
            setCompany(companyDetails);
        }
    }, [companyDetails]);

    const companyCards = company ? (
        <Card className="mb-3">
            <Card.Body>
                <Card.Text>
                    <Card.Title>Customer Company Details</Card.Title>

                    <strong>Company Name:</strong> {company.company_name}
                    <br />
                    <strong>Contact Person Phone:</strong> {company.contact_person_phone}
                    <br />
                    <strong>Company Email:</strong> {company.email}
                    <br />
                    <strong>Company Country:</strong> {company.country}
                    <br />
                    <strong>Company Address:</strong> {company.address}
                    <br />
                    <strong>Company State:</strong> {company.state}
                    <br />
                    <strong>Company City:</strong> {company.city}
                    <br />
                    <strong>Company Area:</strong> {company.area}
                    <br />
                    <strong>Industry:</strong> {company.industry}
                    <br />
                    <strong>Website:</strong> {company.website}
                </Card.Text>
            </Card.Body>
        </Card>
    ) : (
        <p>No company details available.</p>
    );

    return (
        <div className="ViewTransaction">
            <Modal show={showView} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>View Company Details</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ fontSize: "15px", lineHeight: "30px" }}>
                    {companyCards}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button
                        style={{ backgroundColor: "#c4281b" }}
                        onClick={refreshPage}
                    >
                        Refresh
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
